import Datetime from '@/commons/datetime'
import Strings from '@/commons/strings'

/**
 * 格式化时间 'yyyy/MM/dd'
 * @param {*} val 时间
 * @param {*} fmt 格式
 * @return {string} 时间字符串
 */
export function date(val, fmt) {
    return Datetime.format(val, fmt);
}

/**
 * 数字格式化 '0,000.00'
 * @param {*} val 数值
 * @param {*} fmt 格式
 * @return {string} 数字字符串
 */
export function num(val, fmt) {
    if (isNaN(val)) { return val }
    var neg = Strings.startsWith('-') < 0 ? "-" : "";//正负数
    var fix = Strings.contains(fmt, '.') ? fmt.length - (fmt.indexOf('.') + 1) : 0; //小数点位数
    var sep = Strings.contains(fmt, ',') ? fmt.length - (fix > 0 ? fix + 1 : 0) - (fmt.indexOf(',') + 1) : 0; //大数分隔位数

    var zs = Math.floor(Math.abs(val)), xs = (Math.abs(val) - zs).toFixed(fix);//整数部分,小数部分
    var zs_sp = zs;
    if (sep > 0) {
        var j = (j = String(zs).length) > sep ? j % sep : 0;//取出多余的位数
        zs_sp = (j ? String(zs).substr(0, j) + "," : "") + String(zs).substr(j).replace(RegExp("(\\d{" + sep + "})(?=\\d)", "g"), "$1,");
    }
    return neg + zs_sp + String(xs).substr(1);
}

/**
 * 指定中文大于len，用...省略号表示，达到美观效果
 * @param {*} val 需格式的中文
 * @param {*} len 需格式的长度
 */
export function txt(val, len) {
    if (val?.length > len) {
        return val.slice(0, len) + "...";
    } else {
        return val;
    }

}

/**
 * 取数据绝对值
 * @param {*} val 手机号
 */
export function abs(val) {
    return isNaN(val) ? 0 : Math.abs(val.toFixed(2))
}

/**
 * 脱敏手机号码
 * @param {*} val 手机号
 * @return {string} 手机号码
 */
export function mobile(val) {
    return val.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
}


/**
 * 脱敏身份证号
 * @param {*} val 身份证号
 * @return {string} 身份证号
 */
export function idcard(val) {
    if (val) {
        return val.replace(/^(.{4})(?:\d+)(.{4})$/, "$1** **** ****$2");
    }

}




